import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

const modules = {}
function importAll (r) {
  r.keys().forEach(key => {
    const filename = key.replace(/(\.\/|\.js)/g, '')
    modules[filename] = r(key).default
  })
}
importAll(require.context('./modules/', true, /\.js/))

const store = new Vuex.Store({
  getters,
  modules
})

export default store
